import React from 'react';
import {WowImage} from '@wix/wix-ui-tpa/cssVars';
import {type IPromotion} from '../../../../types/galleryTypes';
import s from './PromotionItem.scss';

export enum PromotionItemDataHook {
  Root = 'PromotionItemDataHook.Root',
  Link = 'PromotionItemDataHook.Link',
  Image = 'PromotionItemDataHook.Image',
}

interface PromotionItemProps {
  promotion: IPromotion;
  onClick?: () => void;
}

export const PromotionItem = ({promotion, onClick}: PromotionItemProps) => {
  const {image} = promotion.promotion.media;
  const destinationUrl = promotion.promotion.destinationUrl;
  const handlePromotionClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.();
  };

  const content = (
    <div className={s.imageContainer}>
      <WowImage
        className={s.image}
        data-hook={PromotionItemDataHook.Image}
        src={image.url}
        alt={image.altText || ''}
        sourceWidth={image.width}
        sourceHeight={image.height}
        fluid={true}
        shouldUseLQIP={true}
        encoding="AVIF"
      />
    </div>
  );

  return (
    <div className={s.root} data-hook={PromotionItemDataHook.Root}>
      {destinationUrl ? (
        <a
          className={s.link}
          data-hook={PromotionItemDataHook.Link}
          href={destinationUrl}
          onClick={handlePromotionClick}>
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  );
};
